import axios from 'axios';
import jwtEncode from 'jwt-encode';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://179.50.79.19:5060/api',
});

// Add a request interceptor to generate the JWT token locally
api.interceptors.request.use(
    (config) => {
        const secret = process.env.REACT_APP_API_JWT_SECRET;

        // Formar el payload desde localStorage admin
        let payload = { id: 0, email: 'admin@system', role: 'admin' };
        try {
            const userStr = localStorage.getItem('user');
            if (userStr) {
                const user = JSON.parse(userStr);
                payload = { id: user.id, email: user.email, role: user.role };
            }
        } catch (e) {
            console.error('Error parsing local admin user', e);
        }

        if (secret) {
            const token = jwtEncode(payload, secret);
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            console.warn("REACT_APP_API_JWT_SECRET not configured. API requests may fail.");
            const oldToken = localStorage.getItem('token');
            if (oldToken) config.headers.Authorization = `Bearer ${oldToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;
